import { render, staticRenderFns } from "./HubOverview.vue?vue&type=template&id=67f396ce"
import script from "./HubOverview.vue?vue&type=script&lang=js"
export * from "./HubOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports